import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { WarehousesPage } from '../../features/inventory/warehouses-page'

export const Route = createFileRoute('/_app/warehouses')({
  staticData: { crumb: 'warehouses' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'inventory.read'),
  component: WarehousesPage,
})
